<script>
	import RadioGroup from "./RadioGroup.svelte";

	export let name;
	export let label;
	export let sublabel;
	export let value;

	export let required;
	export let disabled = null;
	export let labelWithTooltip;
	export let tooltipText;
	export let labelBeforeTooltip;
	export let labelAfterTooltip;

	const yesNoOptions = [
		{ label: "Yes", value: "Yes" },
		{ label: "No", value: "No" }
	];
</script>

<RadioGroup
	{disabled}
	{required}
	{name}
	{label}
	{sublabel}
	{tooltipText}
	{labelWithTooltip}
	{labelBeforeTooltip}
	{labelAfterTooltip}
	bind:value
	optionList={yesNoOptions}
	labelProperty="label"
	valueProperty="value"
></RadioGroup>
